<template>
  <div class="document-form-thumbnail">
    <TextLabel
      :label
      :error
      :silent
    />
    <UIImageCropper
      :model-value="image"
      :data-refid
      :loading="disabled"
      :title="label"
      :display-aspect-ratio="8 / 1"
      class="rounded-md"
      @update:model-value="handleUpdate"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'

import { DocumentClass } from '..'

import { DOCUMENT_FIELD } from '../utils/const'

import TextLabel from '@/components/UI/Input/Text/TextLabel.vue'
import { UIImageCropper } from '@ui/controllers'

type Props = {
  instance: DocumentClass
  disabled?: boolean
  label?: string
  dataRefid?: string
}

const props = defineProps<Props>()

const image = ref<File>()

const isSavedDocument = inject('isSavedDocument', ref(false))

const error = computed(() => props.instance.errors.filename)
const silent = computed(() => !isSavedDocument.value)

const handleUpdate = async (data?: File | string) => {
  const file = data as File
  props.instance.field<File>(DOCUMENT_FIELD.FILE).value = file
  props.instance.field<string>(DOCUMENT_FIELD.FILENAME).value = file?.name
  props.instance.field<string>(DOCUMENT_FIELD.NAME).value = file?.name
}
</script>
